import React, { useState, useRef } from "react";
import BitterButtonWithMenu from "./BitterButtonWithMenu";
import UserOverlay from "./UserOverlay";

const BitterButtonParentSimple = () => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const buttonRef = useRef(null);

  const handleOverlayOpen = () => {
    setIsOverlayOpen(true);
  };

  return (
    <>
      <BitterButtonWithMenu
        ref={buttonRef}
        onOverlayOpen={handleOverlayOpen}
      />

      {isOverlayOpen && <UserOverlay onClose={() => setIsOverlayOpen(false)} />}
    </>
  );
};

export default BitterButtonParentSimple;
